import React from 'react';
import { Checkbox } from 'antd/lib/index';

const CacheEnableCheckBoxView = ({ onChange, cacheEnabled, style = {} }) => (
  <Checkbox onChange={onChange} checked={cacheEnabled} style={style}>
    <span style={{ marginLeft: -5 }}>Cache</span>
  </Checkbox>
);

export default CacheEnableCheckBoxView;
